import { createAppTranslation } from '@fiverr-private/i18n-react';
import copies from '../../copies.json';

export const { AppI18n, appTranslate, hasAppTranslation } = createAppTranslation(copies, 'store_builder_perseus');
